import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const ProductImages = ({ images }) => {
  const [mainImage, setMainImage] = useState(images[0]);

  return (
    <div className="product-images">
      <div className="main-image-container mb-3">
        <div className="image-zoom-container">
          <div className="drift-zoom-pane drift-open">
            <div className="drift-zoom-pane-loader"></div>
            <img
              src={mainImage}
              alt="Product"
              className="img-fluid main-image"
              id="main-product-image"
            />
          </div>
        </div>
      </div>

      <div className="product-thumbnails">
        <Swiper
          modules={[Navigation]}
          spaceBetween={10}
          slidesPerView={4}
          navigation
          breakpoints={{
            320: { slidesPerView: 3 },
            576: { slidesPerView: 4 },
          }}
          className="product-thumbnails-slider"
        >
          {images.map((img, idx) => (
  <SwiperSlide key={idx}>
    <div
      className={`thumbnail-item ${mainImage === img ? 'active' : ''}`}
      onClick={() => setMainImage(img)}
      style={{ cursor: 'pointer' }}
    >
      <img src={img} alt={`Thumbnail ${idx + 1}`} className="img-fluid" />
    </div>
  </SwiperSlide>
))}

        </Swiper>
      </div>
    </div>
  );
};

export default ProductImages;